import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSaveBookmarkFilled = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SaveBookmarkFilled</title>
    <path
      d="M18.855 20.562a.429.429 0 0 1-.69.34l-5.907-4.512a.429.429 0 0 0-.52 0l-5.909 4.513a.428.428 0 0 1-.688-.34V5.139c0-1.42 1.15-2.567 2.57-2.567h8.575a2.569 2.569 0 0 1 2.569 2.572v15.418Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSaveBookmarkFilled;
